import React, { useEffect, useState } from 'react';
import SessionConstants from '../../config/SessionConstants';
import { Link as RouterLink } from 'react-router-dom';
import { Warning, ArrowForward, Mail, Error as MuiError } from '@mui/icons-material';

import './index.css';

export default function Error() {
    const [errorMessage, setErrorMessage] = useState(null);
    const [errorDescription, setErrorDescription] = useState(null);
    const [timeout, setTimeoutStatus] = useState(false);

    useEffect(() => {
        console.log('loading error message descriptions');
        let errMsg = sessionStorage.getItem(SessionConstants.ERROR_MESSAGE);
        let errDesc = sessionStorage.getItem(SessionConstants.ERROR_DESCRIPTION);
        let timeoutStatus = sessionStorage.getItem(SessionConstants.TIMEOUT_STATUS);

        setErrorMessage(errMsg);
        setErrorDescription(errDesc);
        setTimeoutStatus(timeoutStatus === "true"); // Convert string to boolean
    }, []);

    return (
        <div className='errorContainer' role='main'>
            <div className='errorBox'>
                <div className='errorTitle'>
                    {timeout ? (
                        <h1>
                            <Warning style={{ fontSize: '3.5rem', marginTop: '-3px', verticalAlign: 'middle' }} /> Logout
                        </h1>
                    ) : (
                        <h1>
                            <MuiError style={{ fontSize: '3.5rem', marginTop: '-8px', verticalAlign: 'middle' }} /> Error
                        </h1>
                    )}
                </div>
                <div className='errorBody'>
                    <div className='errorMessage'>
                        {errorMessage ? (<span>{errorMessage}</span>) : ('')}
                        {(errorMessage && errorDescription) ? (' - ') : ('')}
                        {errorDescription ? (<span>{errorDescription}</span>) : ('')}
                    </div>
                    <div className='errorLoginMessage'>
                        <div className='loginWrapper'>
                            <div>
                                Please login to ED3N again:
                            </div>
                            <div className='linkWrapper'>
                                <RouterLink className='loginLink' to='/landing' role='link' aria-label='login'>
                                    <ArrowForward fontSize='medium' style={{ verticalAlign: 'middle' }} /> Login to ED3N
                                </RouterLink>
                            </div>
                        </div>
                        <div className='emailWrapper'>
                            <div>
                                If you continue to experience problems logging in, please email CDC ED3N support:
                            </div>
                            <div className='linkWrapper'>
                                {errorDescription == null ? (
                                    <a className='emailLink' role='link' aria-label='send email' href="mailto:cdced3nsupport@cdc.gov?Subject=ED3N%20Login%20Problem">
                                        <Mail fontSize='medium' style={{ verticalAlign: 'middle' }} /> CDC ED3N support
                                    </a>
                                ) : (
                                    <a className='emailLink' role='link' aria-label='send email' href={"mailto:cdced3nsupport@cdc.gov?Subject=ED3N%20Login%20Problem%20-%20" + errorDescription}>
                                        <Mail fontSize='medium' style={{ verticalAlign: 'middle' }} /> ED3N support
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}